import React, { useState, useRef, useEffect } from 'react'
import Slider from 'react-slick'
import Image from '../atoms/Image'
import Headline from '../atoms/Headline'
import Link from '../atoms/Link'
import SbEditable from 'storyblok-react'

// TODO: Fix Arrows/Dots
// TODO: Fix Dots Mobile (no section because of arrow-styling)

const ReferenceSliderBlock = ({ block }) => {
  const refChild = useRef()
  const [widthState, setWidthState] = useState(0)
  useEffect(() => {
    setWidthState(refChild.current.offsetWidth)
  })
  function NextArrow(props) {
    const { className, onClick, widthState } = props
    return (
      <span
        className={className}
        style={{ left: 'unset', right: 'calc(50% + 2rem)' }}
        onClick={onClick}
      >
        <i className="fal fa-chevron-right"></i>
      </span>
    )
  }

  function PrevArrow(props) {
    const { className, onClick, widthState } = props
    return (
      <span
        className={className}
        style={{
          left: 'unset',
          right: 'calc(50% + ' + widthState + 'px - (1.5rem + 2rem))',
        }}
        onClick={onClick}
      >
        <i className="fal fa-chevron-left"></i>
      </span>
    )
  }

  const settings = {
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <PrevArrow className="slick-prev" widthState={widthState} />,
    nextArrow: <NextArrow className="slick-next" widthState={widthState} />,
    appendDots: (dots) => (
      <ul style={{ width: widthState + 'px', right: '50%' }}> {dots} </ul>
    ),
    customPaging: (i) => <button>{i + 1}</button>,
  }
  return (
    <SbEditable content={block}>
      <Slider {...settings} className="reference-slider-block">
        {block.reference_slider_block_content?.length > 0 &&
          block.reference_slider_block_content.map((item, index) => (
            <article className="reference-slider-block-item" key={index}>
              <div className="reference-slider-block-item-text-bg">
                <div className="reference-slider-block-item-text-bg-wrapper"></div>
              </div>
              <div
                className="reference-slider-block-item-image-container"
                data-rellax-center={true}
                data-rellax-speed={-1}
              >
                <div className="reference-slider-block-item-image">
                  <Image
                    image={item.image}
                    alt={item.alt}
                    title={item.alt}
                    imageWidth="1280"
                    imageHeight="960"
                  />
                </div>
              </div>
              <div
                className="reference-slider-block-item-text-overlay"
                data-rellax-center={true}
                data-rellax-speed={1}
              >
                <div className="reference-slider-block-item-text-overlay-container">
                  <div className="reference-slider-block-item-text-overlay-wrapper">
                    <div className="reference-slider-block-item-text-overlay-row">
                      <div className="reference-slider-block-item-text-overlay-cell">
                        <div
                          className="reference-slider-block-item-text-overlay-inner"
                          ref={refChild}
                        >
                          <div className="customer-logo">
                            <Image image={item.customer_logo} />
                          </div>
                          <Headline
                            kicker="Referenzen"
                            headline={item.headline}
                          />
                          {item.text?.length > 0 && (
                            <p className="teaser-text">{item.text}</p>
                          )}
                          <div
                            className="btn-group text-center"
                            role="group"
                            aria-label="Button group"
                          >
                            <Link
                              className="btn btn-primary"
                              link={item.link}
                              target={item.tab_link ? '_blank' : '_self'}
                            >
                              {item.link_text}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          ))}
      </Slider>
    </SbEditable>
  )
}

export default ReferenceSliderBlock
